import { CellContext, type RowData } from 'src/lib/tanstack-react-table';
import { CopyTextCellContent } from './CopyTextCellContent';

export const CopyTextCell = <TType extends RowData>({ getValue }: CellContext<TType, string>) => {
  const cellValue = getValue();

  return <CopyTextCellContent value={cellValue} />;
};

export const TextWithCopyTextCell = <TType extends RowData>({ getValue }: CellContext<TType, string>) => {
  const cellValue = getValue();

  return <CopyTextCellContent value={cellValue} displayValue />;
};
